import React from 'react';
import SafeIcon from '../../common/SafeIcon';

export default function Button({ children, variant = 'primary', icon, loading, className = '', ...props }) {
  const baseStyle = "inline-flex items-center justify-center px-4 py-2 rounded-lg font-medium transition-colors disabled:opacity-50 text-sm";
  const variants = {
    primary: "bg-indigo-600 text-white hover:bg-indigo-700 shadow-sm",
    secondary: "bg-white border border-gray-300 text-gray-700 hover:bg-gray-50",
    danger: "bg-red-600 text-white hover:bg-red-700 shadow-sm",
    ghost: "bg-transparent text-gray-600 hover:bg-gray-100"
  };
  
  return (
    <button className={`${baseStyle} ${variants[variant]} ${className}`} disabled={loading} {...props}>
      {loading ? (
        <SafeIcon icon="Loader" className="animate-spin mr-2 w-4 h-4" />
      ) : icon && (
        <SafeIcon icon={icon} className="mr-2 w-4 h-4" />
      )}
      {children}
    </button>
  );
}